<template>
  <b-modal
    id="upload-contract-modal"
    ref="uploadModal"
    v-model="isVisible"
    title="Xác thực tài khoản ngân hàng"
    size="md"
    centered
    @hidden="handleModalHidden"
    @shown="handleModalShown"
  >
    <div class="upload-contract-content">
      <!-- Ảnh xác thực -->
      <div class="upload-section">
        <UploadMultipleCSKH
          ref="merchantUpload"
          :title="'Ảnh xác thực'"
          titleTag="h5"
          titleClass="section-title"
          :accept="'image/jpeg, image/png'"
          :maxFile="200"
          :maxImageFileSize="20"
          :uniqueKey="'merchant'"
          fileType="image"
          @change="handleFileChange"
        />
      </div>
    </div>

    <!-- Custom footer -->
    <template #modal-footer>
      <div class="d-flex justify-content-end align-items-center w-100">
        <div class="d-flex">
          <b-button variant="secondary" class="mr-2" @click="closeModal"> Hủy </b-button>
          <b-button variant="primary" :disabled="!hasAnyFiles" @click="saveFiles">
            <b-spinner v-if="loading" small class="mr-1"></b-spinner>
            Lưu
          </b-button>
        </div>
      </div>
    </template>

    <!-- Modal thông báo -->
    <b-modal id="modal-notification" v-model="showModal">
      <template #modal-header="{ close }">
        <h5>Thông báo</h5>
        <b-button size="sm" variant="light" @click="close()"> × </b-button>
      </template>
      <div class="text-center">
        <img :src="iconNoti" alt="notification" />
        <h2 class="f18 py-3">{{ msgNoti }}</h2>
      </div>
      <template #modal-footer>
        <b-button size="sm" variant="light" @click="closeModal"> Đóng </b-button>
      </template>
    </b-modal>
  </b-modal>
</template>

<script>
  import UploadMultipleCSKH from '@/components/cskh/UploadFIleOrImageMultip.vue'
  import { MerchantService } from '@/services/merchant.service'

  export default {
    name: 'UploadFileVerify',
    components: {
      UploadMultipleCSKH,
    },
    props: {
      visible: {
        type: Boolean,
        default: false,
      },
      initialData: {
        type: Array,
        default: () => [],
      },
      contractId: {
        type: String,
        required: true,
      },
    },
    data() {
      return {
        isVisible: false,
        loading: false,
        showModal: false,
        iconNoti: '',
        msgNoti: '',
        uploadedFiles: [],
      }
    },
    computed: {
      hasAnyFiles() {
        return this.uploadedFiles.length > 0
      },
    },
    watch: {
      visible: {
        handler(newVal) {
          this.isVisible = newVal
        },
        immediate: true,
      },
      isVisible(newVal) {
        if (!newVal) {
          this.$emit('update:visible', false)
        }
      },
    },
    methods: {
      show() {
        this.$refs.uploadModal.show()
      },

      hide() {
        this.$refs.uploadModal.hide()
      },

      handleModalShown() {
        this.loadInitialData()
      },

      handleModalHidden() {
        this.isVisible = false
        this.$emit('update:visible', false)
      },

      loadInitialData() {
        this.$nextTick(() => {
          if (this.initialData && this.initialData.length > 0) {
            const verifyData = this.initialData.map((item, index) => ({
              url: item,
              location: item,
              type: 'verify',
              uploaded: true,
              name: `Ảnh xác thực - ${index + 1}`,
              accessKey: item,
            }))
            this.$refs.merchantUpload?.setData(verifyData)
            this.uploadedFiles = [...verifyData]
          }
        })
      },

      handleFileChange(files) {
        this.uploadedFiles = [...files]
      },

      async saveFiles() {
        try {
          this.loading = true

          const uploadedData = this.$refs.merchantUpload?.getData() || []
          const unuploadedFiles = uploadedData.filter(file => !file.uploaded && file.file)

          // Upload files mới nếu có
          if (unuploadedFiles.length > 0) {
            await this.$refs.merchantUpload?.saveData()
          }

          // Lấy danh sách URL ảnh đã upload
          const finalData = this.$refs.merchantUpload?.getData() || []
          const images = []

          finalData.forEach(file => {
            const imageUrl = file.url || file.s3Url
            if (imageUrl) {
              images.push(imageUrl)
            }
          })

          // Tạo API body theo format mới
          const apiBody = {
            contractId: this.contractId,
            images: images,
          }

          const response = await MerchantService.uploadVerifyImages(apiBody)

          if (response.code === 1000 || response.code === 70040) {
            this.$emit('success')
            this.showNotification(true, 'Đã lưu ảnh xác thực thành công!')
          } else {
            this.showNotification(false, response.message || 'Lỗi khi lưu ảnh xác thực')
          }
        } catch (error) {
          console.error('Lỗi khi lưu ảnh xác thực:', error)
          this.showNotification(false, error.message || 'Lỗi khi lưu ảnh xác thực')
        } finally {
          this.loading = false
        }
      },

      showNotification(isSuccess, message) {
        this.showModal = true
        this.iconNoti = isSuccess
          ? require('@/assets/img/noti-success2.svg')
          : require('@/assets/img/noti-unsuccess2.svg')
        this.msgNoti = message
      },

      closeModal() {
        this.hide()
        this.showModal = false
      },
    },
  }
</script>

<style lang="scss" scoped>
  .upload-contract-content {
    .upload-section {
      margin-bottom: 25px;

      :deep(.section-title) {
        font-size: 16px;
        font-weight: 600;
        color: #333;
        margin-bottom: 15px;
      }
    }
  }

  :deep(.modal-header) {
    background-color: #f8f9fa;
    border-bottom: 1px solid #dee2e6;

    .modal-title {
      font-weight: 600;
      color: #333;
    }
  }

  :deep(.modal-footer) {
    background-color: #f8f9fa;
    border-top: 1px solid #dee2e6;
    padding: 15px 20px;
  }

  :deep(.modal-body) {
    padding: 25px;
  }

  @media (max-width: 768px) {
    :deep(.modal-body) {
      padding: 15px;
    }

    :deep(.modal-footer) {
      padding: 10px 15px;
    }
  }
</style>
